export const REPLACE_SUMMARY_DATA = 'REPLACE_SUMMARY_DATA';
export const REPLACE_SENSORS_DATA = 'REPLACE_SENSORS_DATA';
export const REPLACE_ENTITY_DATA = 'REPLACE_ENTITY_DATA';
export const REPLACE_D_PACKET_DATA = 'REPLACE_D_PACKET_DATA';
export const REPLACE_PACKET_GRAPH = 'REPLACE_PACKET_GRAPH';